import {ViolationTargetModel} from './ViolationTarget.model';
import {cartV2} from '@wix/ecom';

export class ViolationModel {
  public severity: ViolationSeverity;
  public target: ViolationTargetModel;
  public description: string;

  constructor(params: ViolationModel) {
    this.severity = params.severity;
    this.target = params.target;
    this.description = params.description;
  }

  public static fromCartV2(violation: cartV2.V2Violation): ViolationModel {
    return new ViolationModel({
      severity:
        violation.severity === cartV2.ViolationSeverity.ERROR ? ViolationSeverity.error : ViolationSeverity.warning,
      target: ViolationTargetModel.fromCartV2(violation.customValidationData.target),
      description: violation.description,
    });
  }
}

export enum ViolationSeverity {
  error = 'ERROR',
  warning = 'WARNING',
}
